/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
require('babel-polyfill')
import "fetch-polyfill";

const fetchCommon = (url) => {
  return fetch(url).then(res => res.text());
}

export function onClientEntry() {
  if (typeof window.IntersectionObserver === `undefined`) {
    require(`intersection-observer`);

  }
}

export function onInitialClientRender() {
  fetchCommon('/common/include/header-type2.html')
    .then((res) => {
      document.getElementById('global-header').insertAdjacentHTML('beforeend', res);
    });
  fetchCommon('/common/include/footer.html')
    .then((res) => {
      document.getElementById('global-footer').insertAdjacentHTML('beforeend', res);
    });
}
